<template>
    <div class="mealplan">
        <v-row align="center">
            <v-col cols="2">
                <v-btn icon @click="prevWeek">
                    <v-icon v-text="'mdi-arrow-left-bold-circle-outline'"></v-icon>
                </v-btn>
            </v-col>
            <v-col cols="8">
                <span>{{ options }}</span>
            </v-col>
            <v-col cols="2">
                <v-btn icon @click="nextWeek">
                    <v-icon v-text="'mdi-arrow-right-bold-circle-outline'"></v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :items="$store.getters.getMeals"
            :search="search"
            :header-props="{ mobile: false }"
            :loading="isLoading"
            hide-default-footer
            :custom-sort="sortItems"
            locale="de-DE"
            class="headshot">
            <template v-slot:header.date="{ header }">
                {{ header.text }}
            </template>
            <template v-slot:item.date="props">
                <div v-if="canEdit(props.item.puid)"
                     @click="showDialog(props.item.id)"
                     class="mealplan__delete">
                    <v-icon dark>
                        mdi-delete
                    </v-icon>
                </div>
                <v-dialog
                    v-model="showDeleteDialog[props.item.id]"
                    :retain-focus="false"
                >
                    <v-card>
                        <v-card-title class="headline">
                            Wirklich löschen?
                        </v-card-title>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn
                                text
                                @click="showDeleteDialog[props.item.id] = false"
                            >
                                Nein
                            </v-btn>

                            <v-btn
                                color="red darken-4"
                                text
                                @click="deleteItem(props.item.id, props.item.date)"
                            >
                                Ja
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <span class="u-border-circle" v-if="isToday(props.item.date)">
                    HEUTE
                </span>
                <span class="u-border-circle" v-else>
                    {{ props.item.date }}
                </span>
            </template>
            <template v-slot:item.starter="props">
                <v-edit-dialog
                    v-if="canEdit(props.item.puid)"
                    large
                    persistent
                    cancel-text="Abbrechen"
                    save-text="Speichern"
                    @open="updateStarter = props.item.starter"
                    @save="updateMeal(props.item.id,'starter', updateStarter)"
                >
                    <div>{{ props.item.starter }}</div>
                    <template v-slot:input>
                        <div class="mt-4 title">
                            Vorspeise bearbeiten
                        </div>
                        <v-text-field
                            v-model="updateStarter"
                            label="Vorspeise"
                            single-line
                            autofocus
                        ></v-text-field>
                    </template>
                </v-edit-dialog>
                <div v-else>
                    {{ props.item.starter }}
                </div>
            </template>
            <template v-slot:item.main="props">
                <v-edit-dialog
                    v-if="canEdit(props.item.puid)"
                    large
                    persistent
                    cancel-text="Abbrechen"
                    save-text="Speichern"
                    @open="updateMain = props.item.main"
                    @save="updateMeal(props.item.id, 'main', updateMain)"
                >
                    <div>{{ props.item.main }}</div>
                    <template v-slot:input>
                        <div class="mt-4 title">
                            Hauptspeise bearbeiten
                        </div>
                        <v-text-field
                            v-model="updateMain"
                            label="Hauptspeise"
                            single-line
                            autofocus
                        ></v-text-field>
                    </template>
                </v-edit-dialog>
                <div v-else>
                    {{ props.item.main }}
                </div>
            </template>
            <template v-slot:item.dessert="props">
                <v-edit-dialog
                    v-if="canEdit(props.item.puid)"
                    large
                    persistent
                    cancel-text="Abbrechen"
                    save-text="Speichern"
                    @open="updateDessert = props.item.dessert"
                    @save="updateMeal(props.item.id, 'dessert', updateDessert)"
                >
                    <div>{{ props.item.dessert }}</div>
                    <template v-slot:input>
                        <div class="mt-4 title">
                            Nachspeise bearbeiten
                        </div>
                        <v-text-field
                            v-model="updateDessert"
                            label="Nachspeise"
                            single-line
                            autofocus
                        ></v-text-field>
                    </template>
                </v-edit-dialog>
                <div v-else>
                    {{ props.item.dessert }}
                </div>
            </template>
        </v-data-table>
        <v-text-field
            v-if="false"
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
        ></v-text-field>
        <v-dialog
            v-if="emptyDates.length"
            v-model="showEmptyDatesDialog"
            :retain-focus="false"
        >
            <v-card>
                <v-card-title class="[ headline ]  [ orange--text ]">
                    Erinnerung
                </v-card-title>
                <v-card-text class="pb-0">
                    Du hast für folgende Termine noch keinen Eintrag gemacht:
                    <v-list>
                        <v-list-item v-for="(emptyDate, i) in emptyDates"
                                     :key="i"
                                     class="pl-0"
                        >
                            <v-list-item-icon class="mr-2">
                                <v-icon>
                                    mdi-hand-pointing-right
                                </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="emptyDate.date"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        class="orange--text"
                        @click="showEmptyDatesDialog = false"
                    >
                        OK, trage ich nach
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import MealService from '@/services/MealService';
import PlanService from "@/services/PlanService";

moment.locale('de')

export default {
    data() {
        return {
            weekIndex: 0,
            search: '',
            isLoading: false,
            headers: [
                {
                    text: '',
                    value: 'date',
                },
                {
                    text: 'Vorspeise',
                    value: 'starter',
                },
                {
                    text: 'Hauptspeise',
                    value: 'main',
                },
                {
                    text: 'Nachspeise',
                    value: 'dessert',
                }
            ],
            updateStarter: '',
            updateMain: '',
            updateDessert: '',
            showDeleteDialog: [],
            showEmptyDatesDialog: false,
            emptyDates: []
        }
    },
    computed: {
        datesToShow() {
            const days = [];
            for (let i = 0; i <= 6; i++) {
                const day = (moment(this.weekStart).add(i, 'days'))
                if (day.weekday() < 5) {
                    days.push(moment(this.weekStart).add(i, 'days').format('DD.MM.YYYY'))
                }
            }
            return days
        },
        options() {
            return `${this.datesToShow[0]} - ${this.datesToShow[this.datesToShow.length-1]}`
        },
        selectedWeek: {
            get() {
                return this.$store.getters.getSelectedWeek
            },
            set(value) {
                this.$store.commit('SET_SELECTED_WEEK', value)
            }
        },
        selectedYear: {
            get() {
                return this.$store.getters.getSelectedYear
            },
            set(value) {
                this.$store.commit('SET_SELECTED_YEAR', value)
            }
        },
        weekStart() {
            return moment().add(this.weekIndex, 'weeks').startOf('week')
        },
    },
    methods: {
        nextWeek() {
            this.weekIndex++
            this.getMeals()
        },
        prevWeek() {
            this.weekIndex--
            this.getMeals()
        },
        isToday(date) {
            return date === moment().format('DD.MM.YYYY')
        },
        async getMeals() {
            this.isLoading = true
            this.selectedYear = moment(this.weekStart).year()
            this.selectedWeek = moment(this.weekStart).week()
            try {
                this.$store.commit('SET_MEALS', await MealService.getMeals(this.selectedWeek, this.selectedYear))
            } catch (error) {
                console.log(error)
            }
            this.isLoading = false
        },
        async getEmptyDates() {
            const today = moment()
            if (this.$store.getters.getUser.planUsers) {
                for (const planUser of this.$store.getters.getUser.planUsers) {
                    const plans = await PlanService.getEmptyPlans(planUser.puid, today.week(), today.format('yyyy'))
                    this.emptyDates = this.emptyDates.concat(plans)
                }
                this.emptyDates = this.emptyDates.filter(date => moment(date, 'DD.MM.YYYY').weekday() < 5)
                this.showEmptyDatesDialog = !!this.emptyDates.length
            }
        },
        sortItems(items) {
            return items.sort((a,b) => {
                const momentDateA = moment(a.date, 'DD.MM.YYYY')
                const momentDateB = moment(b.date, 'DD.MM.YYYY')
                if (momentDateA.isBefore(momentDateB)) {
                    return -1
                }
                if (momentDateA.isAfter(momentDateB)) {
                    return 1
                }
                return 0
            })
        },
        async updateMeal(id, key, val) {
            try {
                await MealService.updateMeal(id, key, val)
                this.getMeals()
            } catch (error) {
                console.log(error)
            }
        },
        canEdit(puid) {
            return this.$store.getters.isAdmin || this.$store.getters.getUser.planUsers.some(planUser => planUser.puid === puid)
        },
        async deleteItem(id) {
            this.showDeleteDialog[id] = false
            try {
                await MealService.deleteMeal(id)
                this.getMeals()
            } catch (error) {
                console.log(error)
            }
        },
        showDialog(id) {
            this.$set(this.showDeleteDialog, id, true)
        }
    },
    created() {
        this.getEmptyDates()
        this.getMeals()
    }
}
</script>
